import { useState } from 'preact/hooks';
import { BottomSheet } from '../../ui/sheets/BottomSheet';
import { useI18n } from '../../bootstrap/i18n';
import { bootOnce } from '../../bootstrap';
import { IconClose } from '../../ui/icons';

export function AgeCheckSheet(props: {
  open: boolean;
  onConfirm: () => void;
}) {
  const { t } = useI18n(bootOnce().i18n);
  const [busy, setBusy] = useState(false);

  if (!props.open) return null;

  const handleConfirm = async () => {
    setBusy(true);
    // Optimistic: wait a tick then confirm
    await new Promise(r => setTimeout(r, 150));
    props.onConfirm();
    setBusy(false);
  };

  const handleExit = () => {
    const tg = (window as any).Telegram?.WebApp;
    if (tg?.close) {
      tg.close();
    } else {
      window.close();
    }
  };

  return (
    <BottomSheet
      open={props.open}
      onClose={() => {}}
      dismissOnBackdrop={false}
      ariaLabel={t('age_gate.aria_label', 'Age Verification')}
    >
      <div class="sheetContent" style={{ alignItems: 'center', paddingTop: 32 }}>
        
        {/* 18+ Icon */}
        <div
          style={{
            width: 80,
            height: 80,
            borderRadius: 999,
            border: '4px solid rgba(220, 20, 60, 0.5)',
            color: 'rgba(220, 20, 60, 0.95)',
            background: 'rgba(220, 20, 60, 0.1)',
            fontSize: 32,
            fontWeight: 900,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 16,
            boxShadow: '0 0 30px rgba(220, 20, 60, 0.15)'
          }}
        >
          18+
        </div>

        <div class="sheetTitle" style={{ marginBottom: 8 }}>
          {t('age_gate.title', 'Adult Content Only')}
        </div>

        <div class="sheetText" style={{ maxWidth: 320, marginBottom: 24 }}>
          {t('age_gate.text', 'This application contains 18+ content. By continuing, you confirm that you are at least 18 years old.')}
        </div>

        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 12 }}>
          <button
            class="primaryBtn"
            style={{ width: '100%', height: 52, fontSize: 17 }}
            onClick={handleConfirm}
            disabled={busy}
          >
            {busy ? t('common.loading', 'Loading...') : t('age_gate.confirm', 'I am over 18')}
          </button>

          <button
            class="secondaryBtn"
            style={{ width: '100%', height: 44, background: 'transparent', border: '1px solid rgba(255,255,255,0.1)' }}
            onClick={handleExit}
          >
            {t('age_gate.exit', 'Exit')}
          </button>
        </div>

        <div class="muted" style={{ fontSize: 11, marginTop: 20, textAlign: 'center', opacity: 0.5 }}>
          {t('age_gate.legal', 'Strictly prohibited for persons under 18.')}
        </div>
      </div>
    </BottomSheet>
  );
}

